<template>
  <div>
    <div id="nav"></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      a: false,
    }
  }
}
</script>
